import { useQuery } from '@tanstack/react-query';
import { userApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useAdminUserDetail(id: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.organization.adminUserDetail(id ?? -1),
    queryFn: ({ signal }) =>
      userApiClient.getAdminUser(id!, toCancelToken(signal)),
    enabled: id != null && !Number.isNaN(id),
    staleTime: 0,
    meta: { errorContext: 'user detail' },
  });
}
